import { Location } from "@reach/router";
import { FunctionComponent, useEffect, useState } from "react";
import getRoutes from "./routes";
import AppLayout from "./components/layout/Layout";
import { getUsersAndPermissions } from "./utils/helpers/data/userAndPermissions";
import { User } from "./utils/helpers/types";
import UserContext from "./context/user-context";

const App: FunctionComponent = () => {
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    const fetchUserAndPermissions = async () => {
      const response = await getUsersAndPermissions();
      if (response.error) {
        // Update splash screen to show user-fetch failed
        return;
      }
      setUser(response.data);
    };

    fetchUserAndPermissions();
  }, []);
  return user ? (
    <UserContext.Provider value={user}>
      <Location>
        {({ location }) => (
          <AppLayout location={location}>{getRoutes(user)}</AppLayout>
        )}
      </Location>
    </UserContext.Provider>
  ) : (
    <div>Loading</div>
  );
};

export default App;
